export default __webpack_public_path__ + "static/media/eb-ultra-blk-2.09bfcfb7.png";